import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { GetMarketingFlowResponse } from "../../marketing.types";
import { requestGetMarketingFlow } from "./getMarketingFlow.request";

const useMarketingFlow = (
  flowId: string,
  options?: QueryOptions<GetMarketingFlowResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["marketing", "flows", "detail", flowId],
    queryFn: async () => await requestGetMarketingFlow(flowId),
    onError: toastServerError,
    enabled: Boolean(flowId),
    ...options
  });

  return {
    flow: data?.flow ?? undefined,
    steps: data?.steps ?? [],
    enrollments: data?.enrollments ?? [],
    ...rest
  };
};

export default useMarketingFlow;
